import { cssGenerator, view } from '@yola/ws-sdk';
import { DESKTOP_BREAKPOINT } from '../../../common/constants/breakpoints';
import buildPictureElement from '../../../common/helpers/build-picture-element';
import { imageFieldNames } from '../constants/field-names';
import fallbackValues from '../constants/fallback-values';

const { CONTENT_POSITION: CONTENT_POSITION_CLASS } = cssGenerator.constants.classNames;

const formatImageFieldsValuesWithFallbacks = (fieldsValues) => ({
  ...fieldsValues,
  [imageFieldNames.IMAGE_SRC]: fieldsValues[imageFieldNames.IMAGE_SRC] || fallbackValues.IMAGE_SRC,
  [imageFieldNames.IMAGE_POSITION]:
    fieldsValues[imageFieldNames.IMAGE_POSITION] ?? fallbackValues.IMAGE_POSITION,
  [imageFieldNames.IMAGE_SCALE]:
    fieldsValues[imageFieldNames.IMAGE_SCALE] ?? fallbackValues.IMAGE_SCALE,
  [imageFieldNames.IMAGE_ALT]: fieldsValues[imageFieldNames.IMAGE_ALT] ?? '',
});

const mapImageFieldsValuesToAttributes = (fieldsValues) => ({
  src: fieldsValues[imageFieldNames.IMAGE_SRC],
  alt: fieldsValues[imageFieldNames.IMAGE_ALT],
});

const buildImageElementFromFieldsValues = (fieldsValues) => {
  const formattedFieldsValues = formatImageFieldsValuesWithFallbacks(fieldsValues);
  const imageAttributes = mapImageFieldsValuesToAttributes(formattedFieldsValues);

  return buildPictureElement(imageAttributes);
};

const updateImageMediaElementFromFieldsValues = (
  mediaContainerElement,
  fieldsValues,
  breakpoint = DESKTOP_BREAKPOINT
) => {
  const formattedFieldsValues = formatImageFieldsValuesWithFallbacks(fieldsValues);
  const imageSrc = formattedFieldsValues[imageFieldNames.IMAGE_SRC];

  if (imageSrc === fallbackValues.IMAGE_SRC) {
    // Images don't have a working fallback src, so when the src is not provided,
    // we need to set the `placeholder` attribute to indicate this state.
    mediaContainerElement.setAttribute('placeholder', '');
  } else {
    mediaContainerElement.removeAttribute('placeholder');
  }

  // If the previous content was an iframe, it had default scale and position.
  // When the user has already changed scale and position, we need to restore those values.
  const contentPosition = formattedFieldsValues[imageFieldNames.IMAGE_POSITION];
  const contentScale = formattedFieldsValues[imageFieldNames.IMAGE_SCALE];

  const currentClass = mediaContainerElement.getAttribute('class') || '';
  const newClass = view.helpers.getPatchedResponsiveClass({
    currentClass,
    className: CONTENT_POSITION_CLASS,
    value: contentPosition,
    breakpoint,
  });
  mediaContainerElement.setAttribute('class', newClass);

  mediaContainerElement.setAttribute('content-scale', contentScale);
};

export { updateImageMediaElementFromFieldsValues };
export default buildImageElementFromFieldsValues;
